// extracted by mini-css-extract-plugin
module.exports = {"selectEdit":"EditHistory_selectEdit__3yUvU"};